function RoiItem({ item }) {
    const { img, title, stats } = item;
    return (
        <div className='text-dark main-border mt-5 flex w-full max-w-[400px] items-center gap-4 rounded-2xl p-6'>
            <img src={img} alt={title} />
            <div>
                <h3 className='text-xl'>{title}</h3>
                <p className='text-5xl font-bold'>{stats}</p>
            </div>
        </div>
    );
}

export default RoiItem;
